import { render, staticRenderFns } from "./ConsultingPage.vue?vue&type=template&id=66cf0b1f&scoped=true&"
var script = {}
import style0 from "./ConsultingPage.vue?vue&type=style&index=0&id=66cf0b1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf0b1f",
  null
  
)

export default component.exports